// Finite triangular sampling for the calibrated Softer/Edge glow. Size is
// already in renderer pixels. Fractional sizes interpolate the support without
// changing the authored setting; this table contains no source image data.
export function innerGlowFootprint(size: number) {
  const radius = Math.max(0, Math.ceil(size) - 1);
  const weights = Array.from({ length: radius * 2 + 1 }, (_, index) =>
    Math.max(0, size - Math.abs(index - radius))
  );
  const total = weights.reduce((sum, value) => sum + value, 0);
  return {
    order: weights.length,
    kernel: weights.map((value) => value / total).join(' '),
  };
}
